var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendorRedirectIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.156,
    height: 14,
    viewBox: "0 0 22.156 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h14v14H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2681ff",
    d: "M7.083 4.75v1.167H4.167v6.417h6.417V9.417h1.166v3.5a.583.583 0 0 1-.583.583H3.583A.583.583 0 0 1 3 12.917V5.333a.583.583 0 0 1 .583-.583zM13.5 3v4.667h-1.167V4.991L7.787 9.537l-.825-.825 4.545-4.546H8.833V3z",
    transform: "translate(8.656 -1.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorRedirectIcon);
export default __webpack_public_path__ + "static/media/VendorRedirectIcon.43b35f95cab8fae5bf43b778ae844e93.svg";
export { ForwardRef as ReactComponent };